import ColonyBulkAnimals from '@/components/Colony/Edit/BulkAnimals';

export default ColonyBulkAnimals;
